const axios = require('axios');

export function createItems(items, token) {
  return axios
    .post(
      '/api/items/create',
      items,
      {
        headers: { token },
      },
    );
}
export function editItems(items, token) {
  return axios
    .put(
      '/api/items/edit',
      items,
      {
        headers: { token },
      },
    );
}
export function uploadBase64Img(id, extension, base64, token) {
  return axios
    .post(
      '/api/image',
      {
        id,
        extension,
        base64,
      },
      {
        headers: { token },
      },
    );
}
export function getImage(imagegId) {
  return axios
    .get(
      `/api/image/${imagegId}`,
    );
}
export function deleteImg(id, token) {
  return axios
    .post(
      `/api/image/${id}`,
      {},
      {
        headers: { token },
      },
    );
}
export function deleteItems(items, token) {
  return axios
    .post(
      '/api/items/delete',
      items,
      {
        headers: { token },
      },
    );
}

export function getItemSlim(id) {
  return axios
    .get(
      `/api/item/${id}`,
    )
    .then(async (result) => result.data);
}
export function getItem(id) {
  const item = {};
  return axios
    .get(
      `/api/item/${id}`,
      {
        headers: { token: 'allow' },
      },
    )
    .then(async (result) => {
      item.name = result.data.name;
      item.category = result.data.category;
      item.subCategory = result.data.subCategory;
      item.description = result.data.description;
      item.id = result.data.id;
      const images = [];
      result.data.images.forEach((img) => {
        images.push(new Promise((resolve, reject) => {
          getImage(img.id)
            .then((imgData) => {
              resolve(
                {
                  id: img.id,
                  extension: img.extension,
                  base64: imgData.data,
                  new: false,
                  deleted: false,
                },
              );
            })
            .catch(() => reject());
        }));
      });
      const results = await Promise.all(images);
      item.images = results;
      return item;
    });
}

export function getItems() {
  return axios
    .get(
      '/api/items',
    )
    .then((result) => result.data);
}
